var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconHznp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-a5a573a4-d099-48a8-883a-a5a940074ea4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-fc5bc5ec-76ad-4061-a3fc-84baa24654ea{fill:#fff;}.uuid-804be268-2051-48d8-a4f2-ce08e92c57ed{fill:url(#uuid-da6bac50-21de-40fc-aa90-1b5542ace5ea);}.uuid-e3c1596e-cffe-4313-a5b8-79e4285867db{fill:url(#uuid-c7b8b867-e703-47e8-882b-3cfebf33570a);}.uuid-2235125b-3798-448e-8c95-27c93856d299{fill:url(#uuid-2f943207-3304-47c3-a617-a880426c4f6e);}.uuid-d04b9f39-f8c3-47e4-9bc3-67257f79426d{fill:url(#uuid-e940224a-2d3c-497a-b6d7-8ea32db2eddd);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-c7b8b867-e703-47e8-882b-3cfebf33570a",
    x1: 379.06,
    y1: 12017.28,
    x2: 224.81,
    y2: 11797.47,
    gradientTransform: "translate(0 12196.52) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcb415"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#f17387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bd679c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-2f943207-3304-47c3-a617-a880426c4f6e",
    x1: 285.7,
    y1: 12082.89,
    x2: 131.45,
    y2: 11863.07,
    xlinkHref: "#uuid-c7b8b867-e703-47e8-882b-3cfebf33570a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-da6bac50-21de-40fc-aa90-1b5542ace5ea",
    x1: 379.74,
    y1: 12016.81,
    x2: 225.49,
    y2: 11796.99,
    xlinkHref: "#uuid-c7b8b867-e703-47e8-882b-3cfebf33570a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-e940224a-2d3c-497a-b6d7-8ea32db2eddd",
    x1: 286.4,
    y1: 12082.4,
    x2: 132.13,
    y2: 11862.59,
    xlinkHref: "#uuid-c7b8b867-e703-47e8-882b-3cfebf33570a"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-fc5bc5ec-76ad-4061-a3fc-84baa24654ea",
    d: "m-.5-.5h513v513H-.5V-.5Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-e466cfc0-4afc-4a89-920d-32beae7f8462"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-98c8144b-dec5-4cd7-94e4-e43632db0663"
  }, /*#__PURE__*/React.createElement("path", {
    id: "uuid-b9221736-b92d-41f6-87e4-bc740abf3187",
    className: "uuid-e3c1596e-cffe-4313-a5b8-79e4285867db",
    d: "m333.18,294.24v-148.55l51.44-24.04v148.57l-51.44,24.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-ce95b9d0-df5c-42a6-8e59-f0dde20a7b72",
    className: "uuid-2235125b-3798-448e-8c95-27c93856d299",
    d: "m230.28,242.25V93.68l51.44-24.01v148.57l-51.44,24.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-0c5cc7af-7d74-4bfd-9769-9f0b11bb590f",
    className: "uuid-804be268-2051-48d8-a4f2-ce08e92c57ed",
    d: "m230.28,442.33v-148.55l51.44-24.04v148.57l-51.44,24.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-c1d29bfd-a18f-40a8-9647-4855b4556330",
    className: "uuid-d04b9f39-f8c3-47e4-9bc3-67257f79426d",
    d: "m127.38,390.35v-148.57l51.44-24.01v148.57l-51.44,24.01Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHznp);
export default __webpack_public_path__ + "static/media/icon_hznp.1aaf32f76f777187a5e9f0cd635b8565.svg";
export { ForwardRef as ReactComponent };